<template>
  <div>
    <nav class="navbar nav-bar-class" :class="{ 'displayNav': !displaySide}">
      <!-- Collect the nav links, forms, and other content for toggling -->
      <div>
        <aside>
          <section>
            <div class="row">
              <div class="col-sm-3 col-md-3 sidebar-content">
                <div
                  class="sidebar-col"
                  :class="{ 'displaySide': displaySide, 'theme-admin' : roleId && (roleId === 5 || roleId === 7 || roleId === 11) }"
                >
                  <ul id="accordion" style="margin-top:15px;" v-if="roleId">
                    <li
                      class="menu_item active-icon icon-dashboard"
                      :class="{ 'active': activeMenu.indexOf('layout/dashboard') != -1 || activeMenu.indexOf('layout/headlines') != -1 }"
                      v-on:click="redirect('/layout/dashboard');emitEvent()"
                      v-if="roleId!==4 && roleId!==10 && roleId!==12"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">{{$t('dashboard')}}</span>
                      </a>
                    </li>
                    <li
                      class="menu_item active-icon icon-marketplace"
                      :class="{ 'active': activeMenu.indexOf('layout/market-place')!=-1 }"
                      v-on:click="redirect('/layout/market-place');emitEvent()"
                      v-if="roleId!==4 && roleId!==10 && roleId!==12"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">{{$t('marketPlace')}}</span>
                      </a>
                    </li>
                    <li
                      class="menu_item active-icon icon-notification"
                      :class="{ 'active': activeMenu.indexOf('layout/alert')!=-1 }"
                      v-on:click="showAlertPage('/layout/alert');emitEvent()"
                      v-if="roleId!==4 && roleId!==10 && roleId!==12"
                    >
                      <a href="javascript:void(0);">
                        <!-- <span
                          :class="[(roleId === 5 || roleId === 7 || roleId === 11)? 'border-color-admin' : 'border-color-user']"
                          v-if="newNotificationCountFlag"
                        ></span> -->
                        <span class="content">{{$t('notifications')}}</span>
                      </a>
                    </li>
                    <!-- <li
                      class="menu_item active-icon icon-smartdocs"
                      :class="{ 'active': activeMenu.indexOf('layout/smart-docs')!=-1 }"
                      v-on:click="redirect('/layout/smart-docs');emitEvent()"
                      v-if="roleId !== 3 && roleId !== 4 && roleId !== 6 && roleId !== 7 && roleId!==10 && roleId!==12"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">Smart Docs</span>
                      </a>
                    </li> -->
                    <template v-if="roleId!==4 && roleId!==10 && roleId !== 12">
                      <!--<li>
                        <h5 class="main-content-service">Premium Services</h5>
                      </li>-->
                      <template v-for="(service,index) in premiumServices">
                        <template v-if="service.dropdown">
                          <div class="panel custom-panel" v-bind:key="index">
                            <li
                              class="main-content menu_item"
                              :class="[{'active': activeMenu.indexOf(service.dropdown[0].shortPath)!=-1 },service.icon ]"
                              @click="redirect(service.dropdown[0].path);emitEvent()"
                              >
                              <a>
                                <span v-if="service.name === 'Registration Tracker'" class="content">{{$t('compliance')}}<br/><span :class="language === 'English'?'ml-29':'ml-28'" >{{$t('tracker')}}</span></span>
                                <span v-else class="content">{{service.name}}</span>
                              </a>
                            </li>
                          </div>
                        </template>
                      </template>
                    </template>
                    <div class="panel custom-panel"  v-if="roleId !== 4">
                      <li
                        class="main-content menu_item active-icon icon-resources"
                        data-toggle="collapse"
                        data-parent="#collapseOne"
                        href="#collapseOne"
                      >
                        <a>
                          <span class="content">{{$t('resources')}}</span>
                          <span class="content flt-rht mr-rt-15 mt-12" >
                            <img src="/static/images/icons/downArrowUL.svg" class="downCarret" />
                            <img src="/static/images/icons/downArrowUL.svg" class="upCarret" />
                          </span>
                        </a>
                      </li>
                      <div id="collapseOne" class="panel-collapse collapse">
                        <div class="panel-body">
                          <ul class="sub_menu">
                            <li
                              class="menu_item active-icon ptb-8 pt-12"
                              :class="{ 'active': activeMenu.indexOf('layout/tools')!=-1 }"
                              v-on:click="redirect('/layout/tools/classification');emitEvent()"
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content">{{$t('standards')}}</span>
                              </a>
                            </li>
                            <li
                              class="menu_item active-icon pt-12 pt-8 pb-7"
                              :class="{ 'active': activeMenu.indexOf('layout/representationresources')!=-1 }"
                              v-on:click="redirect('/layout/representationresources');emitEvent()"
                            >
                              <a href="javascript:void(0);">
                                <span class="mr-lt-2-6em wrap-content">{{$t('service')}}<br/></span> <span class="mr-lt-2-6em wrap-content">{{$t('providers')}}</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <template v-if="roleId == 10">
                      <li>
                        <h5 class="main-content-service">Premium Services</h5>
                      </li>
                      <template v-for="(service,index) in premiumServices">
                        <li
                        class="menu_item active-icon"
                        v-if="service.id === 3"
                        v-bind:key="index"
                        :class="[{'active': activeMenu.indexOf(service.shortPath)!==-1},service.icon ]"
                        >
                          <a
                           href="javascript:void(0);"
                           v-on:click="redirect(service.path);emitEvent()"
                          >
                            <span class="content wrap-content">{{service.name}}</span>
                          </a>
                        </li>
                      </template>
                    </template>
                    <li
                      class="menu_item active-icon icon-launchpad pt-5 "
                      :class="{ 'active': activeMenu.indexOf('layout/super-admin')!=-1,
                       'portugueseTop' : this.$i18n.locale === 'Portuguese',
                       'pt-6':activeMenu.indexOf('layout/super-admin')!==1,
                       }"
                      v-on:click="redirect('/layout/super-admin');emitEvent()"
                      v-if="roleId==roleInfo['Super Admin']"
                    >
                      <a href="javascript:void(0);">
                        <span class="content" v-if="this.$i18n.locale === 'English'">Launchpad</span>
                        <span class="content" v-if="this.$i18n.locale === 'Portuguese'">Plataforma de<br/><span class="ml-33">lançamento</span></span>
                      </a>
                    </li>
                  </ul>
                  <ul class="menu" v-if="roleId === 5 || roleId === 7 || roleId === 11">
                    <li>
                      <h5 class="main-content-service">Admin</h5>
                    </li>
                    <li
                      class="menu_item active-icon icon-launchpad"
                      v-on:click="redirect('/layout/launchpad');emitEvent();"
                      v-if="roleId === 5 || roleId === 11"
                      :class="{ 'active': activeMenu.indexOf('layout/launchpad')!==-1 }"
                    >
                      <a href="javascript:void(0);">
                        <span class="content">Launchpad</span>
                      </a>
                    </li>
                    <!-- <li
                      class="menu_item active-icon icon-regulatory-alerts"
                      v-if="roleId === 5 || roleId === 7"
                      :class="{ 'active': activeMenu.indexOf('regulatoryUpdatesAdmin')!==-1 }"
                      v-on:click="redirect('/layout/regulatoryUpdatesAdmin');emitEvent();"
                    >
                      <a href="javascript:void(0);">
                        <span class="content wrap-content">Regulatory Watch Admin</span>
                      </a>
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </aside>
      </div>
    </nav>
    <template-popup :displayRep="displayRep" :showSElink='showSElink' v-if="roleId !== 4 && roleId !== 7 && roleId!==10 && roleId !== 12"/>
  </div>
</template>

<script>
import * as moment from 'moment';
import $ from 'jquery';
import { sortBy } from 'lodash';
import EventBus from '../../utils/event-bus';
import { getServices } from '../../apis/marketPlace';
import { getUserNewNotificationsCount } from '../../apis/notification';
import TemplatePopup from '../VirtualTour/TemplatePopup.vue';
import { getSubscriptions } from '../../apis/registrations';

export default {
  components: {
    TemplatePopup,
  },
  props: {
    roleId: Number,
    accountId: Number,
    displaySide: Boolean,
    account_type_id: Number,
    showSEFlag: Boolean,
    roleInfo: Object
  },
  data() {
    return {
      activeMenu: this.$route.path,
      errors: [],
      newNotificationsCount: '',
      newNotificationCountFlag: false,
      newNotificationCountText: 0,
      timer: '',
      premiumServices: [],
      addedServices: [],
      language: '',
      subscriptions: [],
    };
  },
  methods: {
    emitEvent() {
      this.$emit('mobilesidebar');
    },
    showAlertPage(url) {
      this.newNotificationCountFlag = false;
      Object.keys(this.newNotificationsCount).forEach((key) => {
        if (this.newNotificationsCount[key] > 0) {
          this.newNotificationCountFlag = true;
        }
      });
      this.redirect(url);
    },
    async redirect(url) {
      if (url !== this.$route.path) {
        this.$router.push(url);
      }
    },
    async getNewNotificationsCount() {
      this.newNotificationCountFlag = false;
      const response = await getUserNewNotificationsCount();
      this.newNotificationsCount = response;
      Object.keys(response).forEach((key) => {
        if (response[key] > 0) {
          this.newNotificationCountFlag = true;
        }
      });
      if (this.$route.path === '/layout/alert') {
        EventBus.$emit('newNotificationsCount', this.newNotificationsCount);
      }
    },
    todayDate() {
      return moment()
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
    },
    async getServiceList() {
      const services = await getServices();
      // const regIntelArchive = await getRegIntelArchive(this.accountId);
      services.forEach((service) => {
        let data = {};
        if (service.links.length > 0) {
          data.dropdown = sortBy(data.dropdown, 'sequence');
          if (service.id === 1) {
            let datalink = {};
            data.dropdown = [];
            service.links.forEach((link) => {
              if (link.name === 'records') {
                datalink.id = service.id;
                datalink.name = 'Records';
                data.sequence = link.sequence;
                datalink.icon = 'icon-tracker-plus';
                datalink.shortPath = 'layout/registration';
                datalink.path = '/layout/registration';
                data.dropdown.push(datalink);
                datalink = {};
              } else if (link.name === 'reports') {
                datalink.id = service.id;
                datalink.name = 'Reports';
                data.sequence = link.sequence;
                datalink.icon = 'icon-tracker-plus';
                datalink.shortPath = 'layout/report/summary';
                datalink.path = '/layout/report/summary';
                data.dropdown.push(datalink);
                datalink = {};
              }
            });
            data.id = service.id;
            data.name = service.name;
            data.sequence = service.sequence;
            data.icon = 'icon-tracker-plus active-icon';
            data.shortPath = 'trackplusdashboard';
            data.href = 'collapseTrackSidebar';
            data.path = '/layout/trackplusdashboard';
            this.premiumServices.push(data);
            data = {};
          }
        }
      });
      this.premiumServices = sortBy(this.premiumServices, 'sequence');
      if (this.$route.meta.title === 'Registration Tracker') {
        setTimeout(() => {
          $('#collapse_1').collapse('show');
        }, 0);
      }
      if (this.$route.meta.title === 'Regulatory Intelligence') {
        setTimeout(() => {
          $('#collapse_2').collapse('show');
        }, 0);
      }
    },
  },
  async created() {
    this.subscriptions = await getSubscriptions(true);
    localStorage.setItem('subscriptionId', this.subscriptions ? JSON.stringify(this.subscriptions[0].subscriptionId) : '');
    EventBus.$on('highlightNav', (data) => {
      this.activeMenu = data;
    });
    EventBus.$on('updateHeaderMenu', async () => {
      this.subscriptions = await getSubscriptions(true);
    });
    this.language = localStorage.getItem('language');
    this.getServiceList();
    await this.getNewNotificationsCount();
    this.timer = setInterval(this.getNewNotificationsCount, 180000);
    if (this.$route.meta.title === 'Resources' || this.$route.meta.title === 'Resources Dashboard') {
      setTimeout(() => {
        $('#collapseOne').collapse('show');
      }, 0);
    } else if (this.$route.meta.title === 'Compliance Tracker') {
      setTimeout(() => {
        $('#collapseCompliance').collapse('show');
      }, 0);
    }
  },
  computed: {
    displayRep() {
      return this.roleId === 5 || this.roleId === 7 || this.account_type_id === 2 || this.account_type_id === 4;
    },
    showSElink() {
      if (this.roleId && (this.roleId !== 6 || this.roleId !== 4)) {
        return this.showSEFlag;
      }
      return false;
    },
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path;
      EventBus.$emit('activeMenuTitle', to.meta.title);
    },
    activeMenu() {
      EventBus.$on('highlightNav', (data) => {
        this.activeMenu = data;
      });
      if (this.$route.meta.title === 'Registration Tracker' || (this.activeMenu.indexOf('/layout/trackplusdashboard') !== -1)) {
        $('#collapse_1').collapse('show');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('hide');
        $('#collapseCompliance').collapse('hide');
      } else if (this.$route.meta.title === 'Regulatory Intelligence' || (this.activeMenu.indexOf('/layout/regulatoryprocesscharts') !== -1)) {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('show');
        $('#collapseOne').collapse('hide');
        $('#collapseCompliance').collapse('hide');
      } else if (this.$route.meta.title === 'Resources' || this.$route.meta.title === 'Resources Dashboard'
      || (this.activeMenu.indexOf('/layout/resourcesdashboard') !== -1)
      || (this.activeMenu.indexOf('/layout/regsandguidance') !== -1)
      || (this.activeMenu.indexOf('/layout/representationresources') !== -1)
      || (this.activeMenu.indexOf('/layout/market-insights') !== -1)
      || (this.activeMenu.indexOf('/layout/tools') !== -1)) {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('show');
        $('#collapseCompliance').collapse('hide');
      } else if (this.$route.meta.title === 'Compliance Tracker'
      || (this.activeMenu.indexOf('/layout/manage-compliance') !== -1)
      || (this.activeMenu.indexOf('/layout/registration') !== -1)) {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('hide');
        $('#collapseCompliance').collapse('show');
      } else {
        $('#collapse_1').collapse('hide');
        $('#collapse_2').collapse('hide');
        $('#collapseOne').collapse('hide');
        $('#collapseCompliance').collapse('hide');
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.pt-5 {
  padding-top:5px !important
}
.pt-6 {
  padding-top:7px !important
}
.pt-12 {
  /* padding-top:12px !important */
}
.pt-8 {
  padding-top:8px !important
}
.pb-7 {
  padding-bottom:7px !important
}
.ml-29 {
  margin-left:29px;
}
.ml-28 {
  margin-left:28px;
}
.ml-45{
  margin-left: 45px;
}
.ml-33{
  margin-left: 29px;
}
.edit-icon {
  padding-left: 8px;
  font-size: 22px;
  cursor: pointer;
  display: none;
}
.menu_item.icon-prodclassification:hover:before,
.menu_item.icon-prodclassification.active:before {
  background-image: url(/static/images/icons/prod_classification_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 3px;
  float: left;
}
.menu_item.icon-prodclassification:before {
  background-image: url(/static/images/icons/prod_classification_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 3px;
  float: left;
}
.menu_item.icon-launchpad:hover:before,
.menu_item.icon-launchpad.active:before {
  background-image: url(/static/images/icons/Launchpad.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 19px;
  display: inline-block;
  position: relative;
  top: 4px;
}
.menu_item.icon-launchpad.active.portugueseTop:before {
  top: 6px;
}
.menu_item.icon-launchpad:before {
  background-image: url(/static/images/icons/Launchpad.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 19px;
  display: inline-block;
  position: relative;
  top: 4px;
}
.menu_item.icon-marketplace:hover:before,
.menu_item.icon-marketplace.active:before {
  background-image: url(/static/images/icons/MarketNews_UL.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-marketplace:before {
  background-image: url(/static/images/icons/MarketNews_UL.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-submission:hover:before,
.menu_item.icon-submission.active:before {
  background-image: url(/static/images/icons/submission_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-submission:before {
  background-image: url(/static/images/icons/submission_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-smartexchange:hover:before,
.menu_item.icon-smartexchange.active:before {
  background-image: url(/static/images/icons/smartexchange_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-smartexchange:before {
  background-image: url(/static/images/icons/smartexchange_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-smartdocs:hover:before,
.menu_item.icon-smartdocs.active:before {
  background-image: url(/static/images/icons/smart_docs_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-smartdocs:before {
  background-image: url(/static/images/icons/smart_docs.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-post-market:hover:before,
.menu_item.icon-post-market.active:before {
  background-image: url(/static/images/icons/post_market_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-post-market:before {
  background-image: url(/static/images/icons/post_market_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-in-country-rep:hover:before,
.menu_item.icon-in-country-rep.active:before {
  background-image: url(/static/images/icons/incountry_rep_icon_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-in-country-rep:before {
  background-image: url(/static/images/icons/incountry_rep_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-device-reg:hover:before,
.menu_item.icon-device-reg.active:before {
  background-image: url(/static/images/icons/device_registration_hover.svg);
  background-size: 24px 24px;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-device-reg:before {
  background-image: url(/static/images/icons/device_registration.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-consulting:before {
  background-image: url(/static/images/icons/consulting_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-consulting:hover:before,
.menu_item.icon-consulting.active:before {
  background-image: url(/static/images/icons/consulting_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-regulatory-alerts:before {
  background-image: url(/static/images/icons/reg_alerts_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-regulatory-alerts:hover:before,
.menu_item.icon-regulatory-alerts.active:before {
  background-image: url(/static/images/icons/reg_alerts_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  float: left;
}
.menu_item.icon-reg-pathways:before {
  background-image: url(/static/images/icons/reg_pathway_icon.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  top: 3px;
  float: left;
}
.menu_item.icon-reg-pathways:hover:before,
.menu_item.icon-reg-pathways.active:before {
  background-image: url(/static/images/icons/reg_pathway_icon_hover.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  float: left;
  position: relative;
  top: 0px;
}
.menu_item.icon-regulatory-intel:before {
  background-image: url(/static/images/icons/reg_intel_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-regulatory-intel:hover:before,
.menu_item.icon-regulatory-intel.active:before {
  background-image: url(/static/images/icons/reg_intel_icon_hover.svg);
  background-size: 27px 27px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 8px;
  left: -3px;
}
.menu_item.icon-gg:before {
  background-image: url(/static/images/icons/gg_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-gg:hover:before,
.menu_item.icon-gg.active:before {
  background-image: url(/static/images/icons/gg_icon_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-cw:before {
  background-image: url(/static/images/icons/cw.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-cw:hover:before,
.menu_item.icon-cw.active:before {
  background-image: url(/static/images/icons/cw_hover.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
  float: left;
}
.menu_item.icon-tracker-plus:before {
  background-image: url(/static/images/icons/ComplianceTracker_UL.svg);
  background-size: 23px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-tracker-plus:hover:before,
.menu_item.icon-tracker-plus.active:before {
  background-image: url(/static/images/icons/ComplianceTracker_UL.svg);
  background-size: 23px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-resources:before {
  background-image: url(/static/images/icons/resources_new.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-resources:hover:before,
.menu_item.icon-resources.active:before {
  background-image: url(/static/images/icons/resources_new.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-notification:before {
  background-image: url(/static/images/icons/Notification_UL.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item.icon-notification:hover:before,
.menu_item.icon-notification.active:before {
  background-image: url(/static/images/icons/Notification_UL.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}

.sidebar-col.theme-admin {
  background: #055A81;
}
.sidebar-col.theme-admin .main-content-service {
  color: #fff;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px black;
  background-color: gainsboro;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgray;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: gray;
}
.pd-tp-2 {
  padding-top: 2px;
}
.mr-rt-15 {
  margin-right: 15px;
}
.mt-12 {
  margin-top:10px !important;
}
.displaySide {
  display: block !important;
}
.nav-bar-class {
  position: fixed;
  z-index: 90;
}
.navbar {
  padding: 0px;
}
.mr-lt-2-6em {
  margin-left: 2.6em;
}
.custom-panel {
  margin: 0px;
  background-color: unset;
  border: 0px;
  box-shadow: none;
  -webkit-box-shadow: none;
}
.mr-lt-0 {
  margin-left: 0px !important;
}
.flt-rht {
  float: right;
}
.showDas {
  display: block;
}
.sidebar-ul{
  margin-top: 17px;
}
ul {
  margin-bottom: 0px;
  padding: 0px;
}
ul li {
  list-style: none;
}
li a {
  text-decoration: none;
}
.sidebar-col:hover {
  overflow-y: auto;
}
.sidebar-col {
  position: fixed;
  width: 200px;
  overflow-y: hidden;
  top: 0;
  bottom: 0;
  padding-right: 0px;
  background: #ffffff;
  left: 0px;
  margin-top: 50px;
  scrollbar-width: thin;
  /* box-shadow: 0px 4px 10px rgb(0 0 0 / 25%); */
  border-right: 1px solid #D3D3D3;
}
li a span.content {
  margin-left: 8px;
  color: #000000;
  margin-top: 6px;
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;

}
li.active a span {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color:  #000000
}
li a span {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #000000;
}
i {
  color: #000;
}
h5 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  color: #fff;
}
span.font-cls {
  padding-left: 79px;
  position: absolute;
}
li.main-content[aria-expanded="true"] span img.upCarret {
  display: inline-block;
}
li.main-content[aria-expanded="true"] span img.downCarret {
  display: none;
}
li.main-content span img.downCarret {
  display: inline-block;
  /* transform: rotate(180deg); */
  width:20px;
  height: 20px;
}
li.main-content span img.upCarret {
  display: none;
  transform: rotate(180deg);
  width:20px;
  height: 20px;
}
.font-chev {
  padding-left: 13px;
  position: absolute;
}
.rep-one,
.rep-two {
  padding-left: 41px;
}
li.last-content {
  padding-bottom: 10px;
}
.icon-notification .bell-highlight {
  position: absolute;
  top: 107px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #f2c94c;
  color: #fff;
  left: 29px;
}
.border-color-user {
  border: 1px solid #00518a;
}
.border-color-admin {
  border: 1px solid #317381;
}
.menu_item {
  padding-left: 20px;
  cursor: pointer;
}
.menu_item.icon-dashboard::before {
  background-image: url(/static/images/icons/dashboard_new.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
  transform: scale(1.5);
  left: 4px
}
.menu_item.icon-dashboard:hover:before,
.menu_item.icon-dashboard.active:before {
  background-image: url(/static/images/icons/dashboard_new.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 20px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
  transform: scale(1.5);
  left: 4px
}
.menu_item.icon-support::before {
  background-image: url(/static/images/icons/support.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}

.menu_item.icon-support:hover:before,
.menu_item.icon-support.active:before {
  background-image: url(/static/images/icons/support.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  top: 6px;
}
.menu_item:hover {
  /* background: #013a68; */
  opacity: 0.8;
}
.theme-admin li.menu_item:hover {
  /* background: #2a4a58; */
  opacity: 1;
}
/* .theme-admin li.menu_item.active {
  background: #2a4a58;
} */
.wrap-content {
  display: block;
  margin-left: 28px !important;
}
li.menu_item {
  width: 100%;
  padding: 3px 0px 5px 22px;
  opacity: 0.8;
}
li.sub_menu_item {
  width: 100%;
  padding: 10px 0px 10px 38px;
}
.sub_menu_item:hover {
  background: #00518a;
}
li h5.main-content-service {
  padding: 10px 0px 4px 10px;
  color: #ffffff;
}
.panel-body {
  padding: 0px;
}
li.menu_item.active-icon.active {
  padding-left: 22px;
  font-weight: 700;
}
.menu_item.active {
  border-right: 4px solid #CA0123;
  font-weight: 400;
  /* color: #fff; */
  background:  #E6E6E6;
  /* opacity: 1; */
  padding:0px 0px 3px 24px
}
.menu_item.active.ptb-8 {
  padding: 8px 0px 7px 24px !important;
}
.media-sidebar {
  text-align: end;
  padding: 15px 10px 15px 0px;
  background: #0b3c61;
  color: #fff;
  display: none;
}
.fa-chevron-down {
  padding-right: 10px;
}
.fa-chevron-up {
  padding-right: 10px;
}
.fa-adn {
  padding-top: 15px;
}
span.name {
  padding-right: 10px;
}
.media-icons {
  text-align: end;
}
.comp-name {
  margin-bottom: 0px;
}
.main-content-service {
  margin-bottom: 0px;
}
span.content.mt-8 {
  margin-top: 8px;
}

@media only screen and (max-width: 1300px) {
/* .sidebar-ul{
  margin-top: 11px;
} */
  .edit-icon {
    display: inline;
  }
  .sidebar-col {
    display: none;
    overflow-y: auto;
    width: 256px;
    margin-top: 107px;
  }
  .media-sidebar {
    display: block;
  }
  li.sub_menu_item {
    width: 85%;
    padding: 10px 0px 10px 38px;
  }
  .rep-one {
    padding-left: 41px;
  }
  .rep-two {
    padding-left: 41px;
  }
  .displayNav {
    z-index: unset;
  }
}
</style>
